/**
 * Global error handler that silently catches property access errors
 * Returns empty strings instead of crashing the page
 */

export default defineNuxtPlugin(() => {
  // Override global error handler
  window.addEventListener('error', (event) => {
    const error = event.error
    
    // Check if this is specifically a property access error (more restrictive)
    if (error && error.message && (
      error.message.includes('Cannot read properties of undefined') ||
      error.message.includes('Cannot read properties of null') ||
      error.message.includes('Cannot read property') && error.message.includes('of undefined') ||
      error.message.includes('Cannot read property') && error.message.includes('of null')
    )) {
      // Log in development only
      if (process.dev) {
        console.warn('[Silent Error Handler]:', error.message)
      }
      
      // Prevent the error from showing to user
      event.preventDefault()
      return false
    }
  })
  
  // Vue error handler for template errors
  const nuxtApp = useNuxtApp()
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // Check if this is specifically a property access error in templates (more restrictive)
    if (error && error.message && (
      error.message.includes('Cannot read properties of undefined') ||
      error.message.includes('Cannot read properties of null') ||
      error.message.includes('Cannot read property') && error.message.includes('of undefined') ||
      error.message.includes('Cannot read property') && error.message.includes('of null')
    )) {
      // Log in development only
      if (process.dev) {
        console.warn('[Vue Error Handler]:', error.message, 'in', info)
      }
      
      // Return false to prevent default error handling
      return false
    }
    
    // Let other errors propagate normally
    throw error
  }
})